<script lang="ts" setup>

import cobwebSvg from '@shared/ui/images/upsell-halloween/cobweb.svg'
import cobwebSmartestmindsSvg from '@shared/ui/images/upsell-halloween/cobweb-smartestminds.svg'
import cobwebMobileSvg from '@shared/ui/images/upsell-halloween/cobweb-mobile.svg'
import cobwebMobileSmartestmindsSvg from '@shared/ui/images/upsell-halloween/cobweb-mobile-smartestminds.svg'
import { useAppBrand } from '@shared/lib/app-brand'

defineOptions({
  name: 'BannerUpsellCobweb',
})

const TABLET_MEDIA = '(min-width: 740px)'

const { isSmartestMinds } = useAppBrand()

const cobweb = isSmartestMinds ? cobwebSmartestmindsSvg : cobwebSvg
const cobwebMobile = isSmartestMinds ? cobwebMobileSmartestmindsSvg : cobwebMobileSvg
</script>

<template>
  <picture class="banner-upsell-cobweb">
    <source
      :srcset="cobweb"
      :media="TABLET_MEDIA"
    >
    <img
      :src="cobwebMobile"
      class="banner-upsell-cobweb__image"
      alt="Cobweb corner decoration"
    >
  </picture>
</template>

<style scoped lang="scss" src="./BannerUpsellCobweb.scss" />
